import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import selectAgencyDialog from '../audits/dialog.selectAgencyDialog';
import auditCoordinatorMessagesTpl from '../audits/messages/audit.coordinator.messages.html';
import auditDateMessagesTpl from '../audits/messages/audit.finding-date.messages.html';
import auditNameMessagesTpl from '../audits/messages/audit.name.messages.html';
import auditEmailMessagesTpl from '../audits/messages/audit.email.messages.html';
import auditPhoneNumberMessagesTpl from '../audits/messages/audit.phone-number.messages.html';
import auditTypeMessageTpl from '../audits/messages/audit-type.messages.html';
import validator, { name as validatorName } from '../audits/messages/audit-unique-name.validator.directive';
import controller from './edit-audit-dialog.controller';
import template from './edit-audit-dialog.html';
// TODO: missing import or reference
// import auditNotesMessagesTpl from '../audits/validation/audit.notes.messages.html';

class dialogService {
  getOptions($event, {
    audit, agencies, auditTypes, coordinators, dataTypes, refreshAudit
  }) {
    return {
      controller,
      controllerAs: 'editAuditDialogVM',
      locals: {
        audit,
        agencies,
        auditTypes,
        coordinators,
        dataTypes,
        refreshAudit
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editAuditDialog', [
  alerts,
  amDataService,
  constants,
  loaderService,
  selectAgencyDialog,
  ssDialogService,
])
  .directive(validatorName, validator)
  .service('editAuditDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('audit-type.messages.html', auditTypeMessageTpl);
    $templateCache.put('audit.name.messages.html', auditNameMessagesTpl);
    $templateCache.put('audit.email.messages.html', auditEmailMessagesTpl);
    $templateCache.put('audit.phone-number.messages.html', auditPhoneNumberMessagesTpl);
    $templateCache.put('audit.coordinator.messages.html', auditCoordinatorMessagesTpl);
    $templateCache.put('audit.date.messages.html', auditDateMessagesTpl);
    // $templateCache.put('audit.notes.messages.html', auditNotesMessagesTpl); // TODO: missing import or reference
  })
  .name;
